export default __webpack_public_path__ + "static/media/scss.3bd84b23.svg";